import React from 'react';
import { Stack, Table, Text } from '@mantine/core';

import { centsToDollars, moneyFormat } from '@/helpers';
import { PopupEventVendorDetailsCompleted } from '../types';

type PopupCompletedSalesProps = {
  event: PopupEventVendorDetailsCompleted;
};

const PopupCompletedSales: React.FC<PopupCompletedSalesProps> = ({ event: { sales } }) => {
  const gfsCents = sales?.gfsCents || 0;
  const foodTopSales = (sales?.foodTopSales || []).filter((s) => s.count > 0);

  const totals = foodTopSales.reduce(
    (s, item) => ({
      count: s.count + item.count,
      cents: s.cents + item.cents,
      percentGfs: s.percentGfs + item.percentGfs,
    }),
    { count: 0, cents: 0, percentGfs: 0 }
  );
  const showOther = totals.cents < gfsCents;

  return (
    <Stack gap="xs" bdrs="md" bd="1px solid var(--mantine-color-gray-4)">
      <Table fz="sm">
        <Table.Thead>
          <Table.Tr>
            <Table.Th>Item</Table.Th>
            <Table.Th ta="center" w="70px">
              Qty
            </Table.Th>
            <Table.Th ta="right" w="100px">
              (% GFS)
            </Table.Th>
          </Table.Tr>
        </Table.Thead>
        <Table.Tbody>
          {!!foodTopSales.length ? (
            foodTopSales.map(({ name, count, cents, percentGfs }) => (
              <Table.Tr key={name}>
                <Table.Td>{name}</Table.Td>
                <Table.Td ta="center">{count}</Table.Td>
                <Table.Td ta="right">
                  {moneyFormat(centsToDollars(cents))}
                  <br />
                  <Text fz="xs" span inherit c="dimmed">
                    {(Math.abs(percentGfs) * 100).toFixed(2)}%
                  </Text>
                </Table.Td>
              </Table.Tr>
            ))
          ) : (
            <Table.Tr>
              <Table.Td colSpan={3} ta="center" fw="bold">
                No sales available
              </Table.Td>
            </Table.Tr>
          )}
          {showOther && (
            <Table.Tr>
              <Table.Td>Other</Table.Td>
              <Table.Td ta="center">-</Table.Td>
              <Table.Td ta="right">
                {moneyFormat(centsToDollars(gfsCents - totals.cents))}
                <br />
                <Text fz="xs" span inherit c="dimmed">
                  {(Math.abs(1 - totals.percentGfs) * 100).toFixed(2)}%
                </Text>
              </Table.Td>
            </Table.Tr>
          )}
        </Table.Tbody>
        <Table.Tfoot bg="gray.1">
          <Table.Tr>
            <Table.Th tt="uppercase">Total</Table.Th>
            <Table.Th ta="center">{totals.count}</Table.Th>
            <Table.Th ta="right">{moneyFormat(centsToDollars(gfsCents))}</Table.Th>
          </Table.Tr>
        </Table.Tfoot>
      </Table>
    </Stack>
  );
};

export default PopupCompletedSales;
